// import News from './components/News';
import {
  Navigate, Route, Routes
} from "react-router-dom";
import PageTopButton from './components/common/PageTopButton';
import Cookie from './components/cookie/Cookie';
import Footer from './components/layout/Footer';
import Header from './components/layout/Header';
import Index from './pages';
import AboutRoute from './pages/about/AboutRoute';
import FAQ from './pages/faq/FAQ';
import Info from './pages/footer/Info';
import NewsRoute from './pages/news/NewsRoute';
import PriceRoute from './pages/price/PriceRoute';
import QueryRoute from './pages/query/QueryRoute';
import SiteMap from './pages/sitemap/SiteMap';
import SitePolicy from './pages/sitepolicy/SitePolicy';
import Download from './pages/support/Download';
import ICReader from "./pages/support/ICReader";
import Setup from "./pages/support/Setup";
import SupportRoute from './pages/support/SupportRoute';
import Tool from "./pages/support/Tool";
import Themes from './pages/themes/Themes';
import WebProb from './pages/webprob/WebProb';
import ScrollTop from './components/common/scrollTop';
import { useLocation } from "react-router-dom";
import { ImgToBase64 } from './components/common/ImgToBase64';
import { ReactElement, useCallback, useEffect, useState } from 'react';
import { fetchmbed } from './util/fetchmbed';
import { CampaignMessage } from './components/campaign/CampaignGroup';
import { Question, ExclusionCategoryNames, QuestionCategories, QuestionRow, Answer } from "./components/faq/QuestionTab";
import { News, NewsData } from "./components/news/types";
import { ExternalNavigate } from './components/common/ExternalNavigate';

function App() {
  // 現在のURLを取得するためにフックを使用
  const location = useLocation();
  const path = location.pathname;
  const [preloadImages, setPreloadImages] = useState<ReactElement[]>([]);

  // 旧URLからのリダイレクト: お問い合わせ
  if (path === "/contact.php") {
    window.location.href = "/contact/";

  // 旧URLからのリダイレクト: ダウンロード(PSAサービス)
  } else if (path === "/footer/info.html" && location.hash === "#f-1-03") {
    window.location.href = window.location.origin + "/footer/info#s03"
  }

  const addPreloadImage = useCallback((src?: string | null) => {
    if (src == null || src.length === 0) return;
    setPreloadImages((images) => {
      if(images.find((image) => image?.props.src === src) != null) return images;
      return [...images, <ImgToBase64 src={src} preload />];
    })
  }, []);

  /**
   * 動的に取得し表示している画像を、ダウンロードした html ファイルでも表示するために、
   * 事前に全ページ分取得し html 内に埋め込んでおく
   */
  useEffect(() => {
    fetchmbed("/cms/json/price/campaign/data.json")
      .then(response => response.data)
      .then((data: CampaignMessage[]) => {
        data.forEach((item) => {
          item.body.forEach((target) => {
            addPreloadImage(`/cms/images/campaign/${target.image}`)
          })
        })
      });
    
    fetchmbed("/cms/json/faq.json")
      .then(response => response.data)
      .then((data: Question) => {
        ExclusionCategoryNames.forEach((exclusionCategoryName: string) =>
          Object.keys(data).forEach((categoryName: string) =>
            delete data[categoryName][exclusionCategoryName]
          )
        );
        const now = new Date();
        const newQuestionRows: QuestionRow[] =
          Object.keys(data).flatMap((category: string) =>
            Object.keys(data[category])
              .filter((subCategory: string) => !ExclusionCategoryNames.includes(subCategory))
              .flatMap((subCategory: string) =>
                data[category][subCategory].filter((question: QuestionRow) =>
                  question.show_on_top
                  && question.service.includes("PS2")
                  && (new Date(question.publish_date)) <= now
                )
              )
          ).sort((a: QuestionRow, b: QuestionRow) =>
              (new Date(a.modified_date)) < (new Date(b.modified_date)) ? 1 : -1
          ).slice(0, 5);
        newQuestionRows.forEach((item: QuestionRow) => {
          item.answers.forEach((target: Answer) => {
            addPreloadImage(target.image)
          })
        })
      })
    
    fetchmbed("/cms/json/faq/data.json")
      .then(response => response.data)
      .then((data: Question) => {
        ExclusionCategoryNames.forEach((exclusionCategoryName: string) =>
          Object.keys(data).forEach((categoryName: string) =>
            delete data[categoryName][exclusionCategoryName]
          )
        );
        const now = new Date();
        Object.values(data).forEach((questionCategories: QuestionCategories) => {
          Object.keys(questionCategories).forEach((subCategoryName: string) => {
            questionCategories[subCategoryName] = questionCategories[subCategoryName]
              .filter((row: QuestionRow) => row.service.includes("PS2")
                && (new Date(row.publish_date)) <= now)
          })
          Object.values(questionCategories).forEach((subCategory: QuestionRow[]) => {
            subCategory.forEach((item: QuestionRow) => {
              item.answers.forEach((target: Answer) => {
                addPreloadImage(target.image)
              })
            })
          })
        })
      });
    
    fetchmbed("/cms/json/news.json")
      .then(response => response.data)
      .then((data: NewsData) => {
        Object.values(data).forEach((newsList: News[]) => {
          newsList.forEach((news: News) => {
            news.body.forEach((item) => {
              item.images.forEach((target) => {
                addPreloadImage(target.path)
              })
            })
          })
        })
      });

    fetchmbed("/cms/json/news/data.json")
      .then(response => response.data)
      .then((data: NewsData) => {
        Object.values(data).forEach((newsList: News[]) => {
          newsList.forEach((news: News) => {
            news.body.forEach((item) => {
              item.images.forEach((target) => {
                addPreloadImage(target.path)
              })
            })
          })
        })
      });
  }, [addPreloadImage]);

  return (
    <>
      <Header />
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Index/>} />
        <Route path="/about/*" element={<AboutRoute/>}/>
        <Route path="/query/*" element={<QueryRoute/>}/>
        <Route path="/price/*" element={<PriceRoute/>}/>
        <Route path="/support/*" element={<SupportRoute/>}/>
        <Route path="/soft-t2/installer/ddriver" element={<Download/>}/>
        <Route path="/footer/info" element={<Info/>}/>
        <Route path="/news/*" element={<NewsRoute/>}/>
        <Route path="/faq" element={<FAQ/>}/>
        <Route path="/web-prob" element={<WebProb/>}/>
        <Route path="/sitepolicy" element={<SitePolicy/>}/>
        <Route path="/themes" element={<Themes/>}/>
        <Route path="/sitemap" element={<SiteMap/>}/>
        <Route path="/setup" element={<Setup />} />
        <Route path="/icreader" element={<ICReader />} />
        <Route path="/tool" element={<Tool />} />
        <Route path="/themes" element={<Themes />} />

        {/* 旧URLからのリダイレクト: よくあるご質問 */}
        <Route path="/support/faq/index.html" element={<Navigate to="/faq" />} />
        <Route path="/support/faq/faq_20_132.html" element={<Navigate to="/faq/#faq2_2929" />} />
        <Route path="/support/faq/faq_21_230.html" element={<Navigate to="/faq/#faq2_3004" />} />
        <Route path="/support/faq/faq_21_209.html" element={<Navigate to="/faq/#faq2_2992" />} />
        {/* 旧URLからのリダイレクト: 公開情報 */}
        <Route path="/footer/info.html" element={<Navigate to="/footer/info" />} />
        <Route path="/ps2" element={<Navigate to="/footer/info" />} />
        {/* 旧URLからのリダイレクト: サイトポリシー */}
        <Route path="/footer/sitepolicy.html" element={<Navigate to="/sitepolicy" />} />
        {/* 旧URLからのリダイレクト: サイトマップ */}
        <Route path="/footer/sitemap.html" element={<Navigate to="/sitemap" />} />
        {/* 旧URLからのリダイレクト: お問い合わせ */}
        <Route path="/contact.php" element={<ExternalNavigate to="https://www.e-probatio.com/contact" />} />
        <Route path="/contact/" element={<ExternalNavigate to="https://www.e-probatio.com/contact" />} />
        {/* 旧URLからのリダイレクト: 申し込み書作成ツール */}
        <Route path="/web-prob/" element={<ExternalNavigate to="https://www.e-probatio.com/web-prob" />} />

        {/* Not Found */}
        <Route path="*" element={
          // バックエンドで実装されたお問い合わせページの場合以外の無効なURLはTOPページへリダイレクトする
          path !== "/contact" && !path.includes("files") ? <Navigate to="/" /> : <></>
        } />

      </Routes>
      <Cookie />
      <Footer />
      <PageTopButton />
      {preloadImages}
    </>
  );
}

export default App;
